export const getRenderingApiUrl = (): string => {
  return process.env.REACT_APP_DAVINCI_FRONTEND_PDF_RENDERING_URL!;
};
